
import React from "react";
import { FiArrowUpRight } from "react-icons/fi";

const DashboardCard = ({
  title,
  value,
  icon,
  color = "text-blue-600",
  percentage,
  onClick,
}) => {
  return (
    <div
      className="group flex items-center justify-between px-4 py-4 bg-white rounded-xl shadow-sm border border-amber-500 hover:shadow-lg transition-shadow duration-300 ease-in-out"
      onClick={onClick}
    >
      <div className="space-y-1">
        <p className="text-md text-gray-950 font-medium tracking-wide">
          {title}
        </p>

        <p className={`text-3xl font-semibold ${color}`}>{value}</p>

        {percentage && (
          <p className="flex items-center text-sm text-green-500 mt-1 font-medium">
            <FiArrowUpRight className="mr-1" />
            {percentage}%
          </p>
        )}
      </div>

      <div className="flex items-center justify-center w-12 h-12 text-2xl text-white bg-amber-500 rounded-full shadow-lg group-hover:scale-105 transform transition-transform duration-300">
        {icon}
      </div>
    </div>
  );
};

export default DashboardCard;
